<template>
  <router-view />
</template>
<script>
export default {
  name: 'Company'
}
</script>
